import PropTypes from 'prop-types';
import React from 'react';
import SvgIcon from './SvgIcon';
import { actionOnKeyboardPress } from '../utils/browserUtils';

const SpeakerAnimation = (props) => {
    const styles = `speaker-animation ${props.isPlaying ? 'active' : ''}`;
    return (
        <div
            aria-label="speaker"
            role="button"
            className={styles}
            tabIndex={props.isDisabled ? "-1" : 0}
            onKeyDown={(e) => actionOnKeyboardPress(e, props.onClick)}
            onClick={props.onClick}
            id="speaker"
        >
            <SvgIcon ariaHidden={true} ariaLabel="speaker-01" class="lantern-svg" id="speaker-01" />
            <SvgIcon ariaHidden={true} ariaLabel="speaker-02" class="lantern-svg" id="speaker-02" />
            <SvgIcon ariaHidden={true} ariaLabel="speaker-03" class="lantern-svg" id="speaker-03" />
            <SvgIcon ariaHidden={true} ariaLabel="speaker-04" class="lantern-svg" id="speaker-04" />
        </div>
    );
};

SpeakerAnimation.propTypes = {
    isPlaying: PropTypes.bool,
    isDisabled: PropTypes.bool,
    onClick: PropTypes.func,
};

SpeakerAnimation.defaultProps = {
    isPlaying: false,
    onClick: undefined,
    isDisabled: false
};

export default SpeakerAnimation;
